import { render, staticRenderFns } from "./BeneficiariesAmendment.vue?vue&type=template&id=4462f900"
import script from "./BeneficiariesAmendment.vue?vue&type=script&lang=js"
export * from "./BeneficiariesAmendment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports